export default __webpack_public_path__ + "static/diagnosis-1f59beefbede911032475590228ad337.png";